import { API2_HOST } from '@/utils/constants';
import { KEY_VERSION } from '@/utils/constants/api-source-types';

import fetchData from '../http';
import { IBaseResponse } from '../types/common';
import {
  IAuthenticate,
  IAuthenticateResult,
  ISendEmail,
} from '../types/verify';

export const getParams = (params: any) => {
  return { body: JSON.stringify(params) };
};

export function authenticate(params: IAuthenticate) {
  const url = `${API2_HOST}/v3/private/user/authenticate`;
  return fetchData.post<IBaseResponse<IAuthenticateResult>>(
    url,
    getParams(params),
  );
}

// 发送邮箱验证码
export function sendEmail({ email, captchaData, cnt, from }: ISendEmail) {
  const url = `${API2_HOST}/send/email`;
  const params = {
    email, // 邮箱
    cnt,
    from,
    ...captchaData,
    key_version: KEY_VERSION,
  };
  return fetchData.post(url, getParams(params));
}
